// Shared CSV-export helpers. Pulled out of company/Analytics.jsx (the first
// page that needed this) rather than re-typed per caller, since the escaping
// rules below are exactly the part worth NOT getting slightly wrong twice.

/** One safely-escaped CSV cell.
 *
 * Values are interpolated raw otherwise, so a name or email containing a comma
 * or quote silently shifts every following column. The leading apostrophe is
 * the other half: a cell starting with = + - @ is executed as a FORMULA by
 * Excel and Sheets, which turns an exported file into a way to run code on
 * whoever opens it.
 */
export function csvCell(value) {
  if (value === null || value === undefined) return "";
  let text = String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

// Built with fromCharCode rather than a literal escape in a string, so it
// can't be silently re-encoded into an actual embedded BOM byte by whatever
// touches this file next — the point of a BOM is being invisible, which is
// exactly what makes a corrupted one impossible to spot by eye afterward.
const BOM = String.fromCharCode(0xfeff);

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const el = document.createElement("a");
  el.href = url;
  el.download = filename;
  document.body.appendChild(el);
  el.click();
  el.remove();
  URL.revokeObjectURL(url);
}

/** Build and download a CSV file from `rows` (array of arrays — the first is
 * the header). Adds a UTF-8 BOM so Excel doesn't mangle non-ASCII names.
 */
export function downloadCsv(rows, filename) {
  const csv = rows.map((r) => r.map(csvCell).join(",")).join("\r\n");
  downloadBlob(new Blob([BOM + csv], { type: "text/csv;charset=utf-8" }), filename);
}
